export const normalizeCode = (input: string) => {
  return input.toUpperCase().replace(/-/g, "_").trim();
};
